import type {
  UserNotificationCreateInput,
  UserNotificationEntryResponse,
  UserNotificationGovernmentsQuery,
  UserNotificationGovernmentSummary,
  UserNotificationListQuery,
} from '@govinity/validation';

import Api from './base';

export const PATH = '/me/notifications';

class UserNotificationsApi extends Api<UserNotificationEntryResponse, object, object, object> {
  getPath() {
    return PATH;
  }

  async createSubscription(body: UserNotificationCreateInput): Promise<void> {
    await this.request({
      data: body,
      method: 'POST',
      url: this.getPath(),
    });
  }

  /**
   * Returns notification rows for the current user filtered by government and resource type.
   */
  async list(query: UserNotificationListQuery): Promise<UserNotificationEntryResponse[]> {
    const { data } = await this.request<UserNotificationEntryResponse[]>({
      method: 'GET',
      params: {
        governmentId: query.governmentId,
        resourceType: query.resourceType,
      },
      url: this.getPath(),
    });

    return data;
  }

  /**
   * Returns governments where the user has at least one notification for the given resource type.
   */
  async getGovernments(
    query: UserNotificationGovernmentsQuery
  ): Promise<UserNotificationGovernmentSummary[]> {
    const { data } = await this.request<UserNotificationGovernmentSummary[]>({
      method: 'GET',
      params: {
        resourceType: query.resourceType,
      },
      url: `${this.getPath()}/governments`,
    });

    return data;
  }

  /**
   * Deletes a notification by id for the current user; responds with 204 (including when the row was not found).
   */
  async remove(notificationId: number): Promise<void> {
    await this.request({
      method: 'DELETE',
      url: `${this.getPath()}/${notificationId}`,
    });
  }
}

export default new UserNotificationsApi();
